import React, { ReactNode } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';

// The below is a "publishable key", which Stripe documents
// is fine to publish within JavaScript code
// https://stripe.com/docs/keys
const stripePromise = loadStripe(process.env.GATSBY_STRIPE_PK!);

interface StripeProviderProps {
  children: ReactNode;
}

const StripeProvider = ({ children }: StripeProviderProps) => (
  <Elements
    options={{
      fonts: [
        {
          src: 'url(/fonts/ask/UniversLTStd.woff)',
          family: 'UniversLTStd',
          style: 'normal',
          display: 'swap',
          weight: '300',
        },
        {
          src: 'url(/fonts/zizzi/DIN-Regular.woff)',
          family: 'Din',
          style: 'normal',
          display: 'swap',
          weight: '200',
        },
      ],
    }}
    stripe={stripePromise}
  >
    {children}
  </Elements>
);

export default StripeProvider;
